import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import './NotFoundPage.scss';
import { trans } from '../../localization';

class NotFoundPage extends React.Component {
  render() {
    const { history } = this.props;
    return (
      <div id="not-found-page">
        <div className="card-content">
          <span className="card-title">{trans('page_not_found')}</span>
          <p>{trans('page_not_found_message')}</p>
        </div>
        <div className="card-action">
          <span className="button-not-found" onClick={history.goBack}>
            {trans('go_back')}
          </span>
          <Link className="button-not-found" to="/">
            {trans('go_homepage')}
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouter(NotFoundPage);



// WEBPACK FOOTER //
// ./foody/src/components/NotFound/NotFoundPage.jsx